import { render, staticRenderFns } from "./userView.component.vue?vue&type=template&id=71f88ede&scoped=true&"
import script from "./userView.component.vue?vue&type=script&lang=js&"
export * from "./userView.component.vue?vue&type=script&lang=js&"
import style0 from "./userView.component.vue?vue&type=style&index=0&id=71f88ede&lang=scss&scoped=true&"
import style1 from "./userView.component.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f88ede",
  null
  
)

export default component.exports